import { Tooltip } from 'antd';
import { graphXAxisLabelFontSize } from 'components/organism/GrowthAnalysis/BrandValueChartContainer/BrandValueChartContainer';
import { colorConstants } from 'config/colorConstants';
import { UserContext } from 'contexts/ConfigContext';
import React, { FC, useContext } from 'react';
import { ellipseMiddleString, getConfig } from 'utils/helperMethods';

type Props = {
    width: number;
    item: any;
};

const GraphXAxisLabelItem: FC<Props> = ({ width, item }) => {
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const showFullLabel = commonConfig?.showFullLabel;
    return (
        <div
            style={{
                width,
                overflowWrap: 'anywhere',
                // wordBreak: 'break-word',
                fontSize: graphXAxisLabelFontSize,
            }}
            className="text-center p-[2px]"
        >
            {showFullLabel ? (
                item?.category
            ) : (
                <Tooltip
                    placement="top"
                    color="white"
                    destroyTooltipOnHide
                    overlayStyle={{ borderRadius: 4 }}
                    overlayInnerStyle={{
                        fontSize: graphXAxisLabelFontSize,
                        color: colorConstants.darkGrey,
                    }}
                    title={item?.category}
                >
                    <div>{ellipseMiddleString(item?.category, 8, 3)}</div>
                </Tooltip>
            )}
        </div>
    );
};

export default GraphXAxisLabelItem;
